import { render } from "./Zapis.vue?vue&type=template&id=bf732392&scoped=true"
import script from "./Zapis.vue?vue&type=script&lang=js"
export * from "./Zapis.vue?vue&type=script&lang=js"

import "./Zapis.vue?vue&type=style&index=0&id=bf732392&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf732392"]])

export default __exports__